import { Spinner, Message } from '..'
import { useState, useEffect } from 'react'
import useServicesHook from '../../api/services'

const FormServices = ({
  edit,
  id,
  licenseId,
  service,
  formCleanHandler,
  isLoading,
  isError,
  handleSubmit,
  submitHandler,
  error,
}) => {

  var [name, setName] = useState('')
  var [description, setDescription] = useState('')
  var [path, setPath] = useState('')
  var [license, setLicense] = useState('')
  var [isPublic, setIsPublic] = useState(false)
  var [defaultValue, setDefaultValue] = useState(false)
  var [active, setActive] = useState(false)
  var [type, setType] = useState('none.jpg')
  const { postService, updateService } = useServicesHook({ page: 1, q: '' })
  const { isLoading: isLoadingPost, mutateAsync: mutateAsyncPost, isError: isErrorPost, error: errorPost, isSuccess: isSuccessPost } = postService
  const { isLoading: isLoadingUpdate, mutateAsync: mutateAsyncUpdate, isError: isErrorUpdate, error: errorUpdate, isSuccess: isSuccessUpdate } = updateService

  useEffect(() => {
  }, [type,defaultValue,active])


  useEffect(() => {
    if (edit) {
      setName(service.name)
      setDescription(service.description)
      setPath(service.path)
      setIsPublic(service.isPublic)
      setDefaultValue(service.defaultValue)
      setActive(service.active)
      setType(service.type)
    } else {
      cleanServiceFunction()  
    } 
  }, [service])

  useEffect(() => {
    setLicense(licenseId)
  }, [license])

  // Metodo para agregar un servicio 
  const addServiceFunction = async () => {

    setLicense(licenseId)

    await mutateAsyncPost({
      name: name,
      description: description,
      path: path,
      isPublic: isPublic,
      defaultValue: defaultValue,
      active: active,
      type: type,
      licenseId: license
    })

    document.getElementById("close-service-modal").click()
    cleanServiceFunction()
    formCleanHandler()
  }

  // Metodo para editar un servicio
  const editServiceFunction = async () => {

    setName(name)
    setDescription(description)
    setPath(path)
    setIsPublic(isPublic)
    setDefaultValue(defaultValue)
    setActive(active)
    setType(type)
    setLicense(licenseId)

    await mutateAsyncUpdate({
      _id: id,
      name: name,
      description: description,
      path: path,
      isPublic: isPublic,
      defaultValue: defaultValue,
      active: active,
      type: type,
      licenseId: license
    })

    document.getElementById("close-service-modal").click()
    cleanServiceFunction()
    formCleanHandler()
  }


  // Metodo para limpiar un servicio
  const cleanServiceFunction = () => {

    setName('')
    setDescription('')
    setPath('')
    setIsPublic(false)
    setDefaultValue(false)
    setActive(false)
    setType('none.jpg')
  }

  // Metodo para agregar imagen
  const addImageType = async (type) => {
    setType(type)
  }

  return (
    <div
      className='modal fade'
      id='serviceModal'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='serviceModalLabel'
    >
      {isErrorPost && <Message variant='danger'>{errorPost}</Message>}
      {isErrorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
      
      {isSuccessPost && (
        <Message variant='success'>Servicio creado correctamente.</Message>
      )}

      {isSuccessUpdate && (
        <Message variant='success'>Servicio actualizado correctamente.</Message>
      )}

      <div className='modal-dialog'>
        <div className='modal-content modal-background'>
          <div className='modal-header'>
            <h3 className='modal-title ' id='serviceModalLabel'>
              {edit ? 'Editar Servicio' : 'Crear Servicio'}
            </h3>
            <button
              id='close-service-modal'
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={formCleanHandler}
            ></button>
          </div>
          <div className='modal-body'>

            {isLoading ? (
              <Spinner />
            ) : isError ? (
              <Message variant='danger'>{error}</Message>
            ) : (
              <form onSubmit={handleSubmit(submitHandler)}>


                <div className='row'>

                  <div className='col-md-6'>
                    <label htmlFor="path"><b>Nombre:</b></label>
                    <input
                      type='text'
                      name='name'
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                      className='form-control'
                    />
                  </div>

                  <div className='col-md-6'>
                    <label htmlFor="path"><b>Descripción:</b></label>
                    <input
                      type='text'
                      name='description'
                      value={description}
                      onChange={(event) => setDescription(event.target.value)}
                      className='form-control'
                    />
                  </div>

                  <div className='col-md-12'>
                    <label htmlFor="path"><b>Ruta:</b></label>
                    <input
                      type='text'
                      name='path'
                      value={path}
                      onChange={(event) => setPath(event.target.value)}
                      className='form-control'
                    />
                  </div>

                  <div className='col-md-6'>
                    <label htmlFor="isPublic"><b>Es Público?:</b></label>
                    <div className='form-check form-switch form-control'>
                      <input className='form-check-input'
                        type='checkbox'
                        id='isPublic'
                        name='isPublic'
                        value={isPublic}
                        onChange={(event) => setIsPublic(event.target.checked)}
                      />
                      <label className='form-check-label' htmlFor='isPublic'>
                        Público
                      </label>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <label htmlFor="default"><b>Por defecto?:</b></label>
                    <div className='form-check form-switch form-control'>
                      <input className='form-check-input'
                        type='checkbox'
                        id='default'
                        name='default'
                        value={defaultValue}
                        onChange={(event) => setDefaultValue(event.target.checked)}
                      />
                      <label className='form-check-label' htmlFor='default'>
                        Defecto?
                      </label>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <label htmlFor="active"><b>Estado:</b></label>
                    <div className='form-check form-switch form-control'>
                      <input className='form-check-input'
                        type='checkbox'
                        id='active'
                        name='active'
                        value={active}
                        onChange={(event) => setActive(event.target.checked)}
                      />
                      <label className='form-check-label' htmlFor='active'>
                        Activo
                      </label>
                    </div>
                  </div>
                  <div className='col-md-12'>
                    <br></br>
                  </div>

                  <div className='col-md-6'>

                    <label htmlFor="type"><b>Tipo de Botón:</b></label>
                    <select onChange={(event) => addImageType(event.target.value)}
                      id='type' name='type' className='form-control' value={type}>
                      <option value="none.jpg">Seleccione una opcion</option>
                      <option value="boton-principal.png">Botón Principal</option>
                      <option value="bomberos.png">Botón Disuasión</option>
                    </select>
                  </div>
                  <div className='col-md-6 text-center'>
                    <div >
                      <img src={`${process.env.PUBLIC_URL}/botones/${type}`} alt="" style={{ width: '100px', height: '100px', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundColor: 'black' }} />

                    </div>
                  </div>
                  <div className='col-md-12'>
                    <br></br>
                  </div>

                </div>



                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-secondary '
                    data-bs-dismiss='modal'
                    onClick={formCleanHandler}
                  >
                    Cerrar
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary '
                    onClick={() => edit ? editServiceFunction() : addServiceFunction()}
                    disabled={isLoadingPost || isLoadingUpdate}
                  >
                    {isLoadingPost || isLoadingUpdate ? (
                      <span className='spinner-border spinner-border-sm' />
                    ) : (
                      ''
                    )}
                    {edit ? ('Editar') : ('Crear')}

                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormServices
